<template>
    <rkm-area
        :subtitle="subtitle"
        title="Avaliação do trauma por partes do corpo"
        type="fieldset"
    >
        <template slot="trailing">
            <rkm-button
                @click="internalVisible = !internalVisible"
                color="primary"
                small
            >
                <rkm-icon :icon="internalVisible ? 'angle-double-up' : 'angle-double-down'" />
            </rkm-button>
        </template>

        <rkm-collapse :visible="internalVisible">
            <Form :data="data" />
        </rkm-collapse>
    </rkm-area>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    computed: {
        subtitle() {
            if (this.data.form.dataHora) {
                return this.data.form.dataHora.concat(
                    ' | ',
                    this.data.form.lotacao.profissional.nome
                )
            } else {
                return ''
            }
        }
    },
    created() {
        this.internalVisible = this.visible
    },
    data: () => ({
        internalVisible: false,
    }),
    props: {
        data: { type: Object, required: true },
        visible: { type: Boolean, default: true },
    },
}
</script>